import {
  ManuallyPassMemberModal,
  MemberEditAccountInformationModal,
  MemberEnrollKindbridgeModal,
  MemberManageGroupsModal,
  MemberManageLegacyRulesetsModal,
  MemberManageTinCollectionModal,
  MemberManageVipStatusModal,
  MemberResetPasswordModal,
  MemberUpdateActivationModal
} from '@bo-components/members/modal';
import type {
  MemberOverlayNameActive,
  MemberProfile
} from '@library/types/members';
import { CreateMemberAdjustmentModal } from '@bo-components/members/memberAdjustments';
import { CreateMemberNoteModal } from '@bo-components/members/memberNotes';
import { MemberChangeLogDrawer } from '@bo-components/members/drawer';

export interface MemberDetailsOverlaysProps {
  memberProfile: MemberProfile;
  onCloseOverlay: () => void;
  overlayActive: MemberOverlayNameActive;
}

export const MemberDetailsOverlays = ({
  memberProfile,
  onCloseOverlay,
  overlayActive
}: MemberDetailsOverlaysProps) => {
  const {
    changeLogDrawerActive,
    createAdjustmentModalActive,
    createNoteModalActive,
    editAccountInformationModalActive,
    enrollKindbridgeModalActive,
    manageLegacyRulesetModalActive,
    manageMemberGroupsModalActive,
    manageTinCollectionModalActive,
    manageVipStatusModalActive,
    manuallyPassMemberModalActive,
    resetPasswordModalActive,
    updateMemberActivationModalActive
  } = overlayActive;

  const { memberOverlayInfo } = memberProfile;
  const {
    accountInformation,
    isDeactivated,
    isVipMember,
    memberId,
    memberEmail,
    memberRulesetId,
    memberRulesetName,
    needsTid,
    tidValidation,
    vipHostAssignedId
  } = memberOverlayInfo;

  return (
    <>
      {changeLogDrawerActive && (
        <MemberChangeLogDrawer memberId={memberId} onClose={onCloseOverlay} />
      )}
      {createAdjustmentModalActive && (
        <CreateMemberAdjustmentModal
          memberId={memberId}
          onCancelModal={onCloseOverlay}
        />
      )}
      {createNoteModalActive && (
        <CreateMemberNoteModal onClose={onCloseOverlay} />
      )}
      {editAccountInformationModalActive && (
        <MemberEditAccountInformationModal
          accountInformation={accountInformation}
          memberId={memberId}
          onClose={onCloseOverlay}
        />
      )}
      {enrollKindbridgeModalActive && (
        <MemberEnrollKindbridgeModal
          memberId={memberId}
          onClose={onCloseOverlay}
        />
      )}
      {manageMemberGroupsModalActive && (
        <MemberManageGroupsModal memberId={memberId} onClose={onCloseOverlay} />
      )}
      {manageLegacyRulesetModalActive && (
        <MemberManageLegacyRulesetsModal
          memberId={memberId}
          memberRulesetId={memberRulesetId}
          memberRulesetName={memberRulesetName}
          onClose={onCloseOverlay}
        />
      )}
      {manageTinCollectionModalActive && (
        <MemberManageTinCollectionModal
          memberId={memberId}
          needsTid={needsTid}
          onClose={onCloseOverlay}
          tidValidation={tidValidation}
        />
      )}
      {manageVipStatusModalActive && (
        <MemberManageVipStatusModal
          isVipMember={isVipMember}
          memberId={memberId}
          onClose={onCloseOverlay}
          vipHostAssignedId={vipHostAssignedId}
        />
      )}
      {manuallyPassMemberModalActive && (
        <ManuallyPassMemberModal memberId={memberId} onClose={onCloseOverlay} />
      )}
      {resetPasswordModalActive && (
        <MemberResetPasswordModal
          memberEmail={memberEmail}
          onClose={onCloseOverlay}
        />
      )}
      {updateMemberActivationModalActive && (
        <MemberUpdateActivationModal
          isDeactivated={isDeactivated}
          memberId={memberId}
          onClose={onCloseOverlay}
        />
      )}
    </>
  );
};
